import styled from 'styled-components';

import { InlineDiv, Span } from 'common/styles/oc-styled-components';
import { colors, FONT_FAMILIES } from 'common/styles/style-constants';
import { Icon } from 'opencare-crown';

export const RatingCount = styled(InlineDiv)`
  color: ${colors.slate};
  font-size: 14px;
  /* This is an invalid rule */
  /* font-weight: 'normal'; */
  margin-left: 4px;
`;

export const StarIcon = styled(Icon).attrs({
  type: 'star',
  theme: 'filled',
})`
  && {
    color: ${colors.yellow};
    margin-right: 10px;
  }
`;

export const InfoText = styled(Span)`
  font-weight: normal;
  font-family: ${FONT_FAMILIES.openSans};
  color: ${colors.slate};
  margin: ${props => props.margin};
`;
